import { skipToken, useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { IUADashboardPayload } from '~/api/user-acquisition'
import type { IUADashboardConfig, IUADashboardData } from '~/types/user-acquisition'

import { getUADashboardConfig, getUADashboardData } from '~/api/user-acquisition'

////////// KEYS //////////

export const keys = {
  all: ['user-acquisition'] as const,
  uaDashboardConfig: () => [...keys.all, 'ua-dashboard-config'] as const,
  uaDashboardData: (payload: IUADashboardPayload) => [...keys.all, 'ua-dashboard-data', payload] as const,
}

////////// QUERIES //////////

export const useUADashboardDataQuery = (payload?: IUADashboardPayload): UseQueryResult<IUADashboardData> =>
  useQuery({
    queryFn: !!payload ? () => getUADashboardData(payload as IUADashboardPayload) : skipToken,
    queryKey: keys.uaDashboardData(payload as IUADashboardPayload),
  })

export const useUADashboardConfigQuery = (): UseQueryResult<IUADashboardConfig> =>
  useQuery({
    queryFn: getUADashboardConfig,
    queryKey: keys.uaDashboardConfig(),
  })
